var parseVersion = function (version) {
    if (version === void 0) { version = ''; }
    var result = version.match(/(\d+)\.(\d+)\.(\d+)/);
    if (result) {
        return result.slice(1, 4);
    }
};
/**
 * 判断API是否能在当前版本APP执行
 * @param a APP当前版本号
 * @param b API需求的版本号
 * @returns APP版本号是否大于等于API需求的版本号
 */
export var canExecute = function (a, b) {
    var arr1 = parseVersion(a), arr2 = parseVersion(b);
    if (!arr1) {
        return false;
    }
    if (!arr2) {
        return true;
    }
    var v1 = +"".concat(new Array(3).fill(0).join('').slice(arr1[0].length, 3)).concat(arr1[0]).concat(new Array(3)
        .fill(0)
        .join('')
        .slice(arr1[1].length, 3)).concat(arr1[1]).concat(new Array(2).fill(0).join('').slice(arr1[2].length, 2)).concat(arr1[2]);
    var v2 = +"".concat(new Array(3).fill(0).join('').slice(arr2[0].length, 3)).concat(arr2[0]).concat(new Array(3)
        .fill(0)
        .join('')
        .slice(arr2[1].length, 3)).concat(arr2[1]).concat(new Array(2).fill(0).join('').slice(arr2[2].length, 2)).concat(arr2[2]);
    return v1 >= v2;
};
